import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const DogIcon = createSvgIcon(
  <>
    <circle cx="16" cy="16" fill="#222222" r="6" />
  </>
)
